import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Chef.css';

const Chef = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.chef} alt="chef_image" />
    </div>
    <div className="app__wrapper_info">
      <SubHeading title="Chef's word" />
      <h1 className="headtext__cormorant">What we believe in</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="quote_image" />
          <p className="p__opensans">Meet our head chef, who brings a wealth of experience and culinary expertise to our business.</p>
        </div>
        <p className="p__opensans"> Our chef is passionate about creating delicious, authentic halal dishes that are sure to please any palate. They take pride in using only the freshest and highest-quality ingredients in their cooking, and are always experimenting with new flavors and techniques to keep our menu exciting. </p>
      </div>

      <div className="app__chef-sign">
        <p>Muhammad Danial Ikram</p>
        <p className="p__opensans">Chef & Founder</p>
        <img src={images.sign} alt="sign_image" />
      </div>
    </div>
  </div>
);

export default Chef;